import { mmFetchWithResponse } from './mmFetchWithResponse';

const pricingApi = {
    getSellableItemPrices: async (packGroupID) => {
        const url = `api/customize/v1/zonePricing/prices?packGroupID=${packGroupID}`;
        return mmFetchWithResponse(url);
    },
    uploadSellableItemPrices: async (packGroupID, pricingZoneID, data) => {
        const formData = new FormData();
        formData.append('file', data.file);
        formData.append('packGroupID', packGroupID);
        formData.append('pricingZoneID', pricingZoneID);

        const url = `api/customize/v1/zonePricing/prices/upload`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    },
    confirmSellableItemPrices: async (key) => {
        const url = 'api/customize/v1/zonePricing/prices/confirm';
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ key }),
        });
        return response;
    },
    getPricingZones: async () => {
        const url = 'api/customize/v1/zonePricing/zones';
        return mmFetchWithResponse(url);
    },
};

export { pricingApi };
